<script setup lang="ts">
import { CopilotRoleEnum } from "~/utils/enums/copilot/chat.enums";
import { messageBubbleClassOf, messageSpeakerLabelOf } from "~/utils/helpers/copilot/message-layout";

const props = withDefaults(
  defineProps<{
    role: CopilotRoleEnum;
    /** Drops the bubble background, for blocks that already carry their own card (attached file). */
    bare?: boolean;
    /** Lets a waiting-state card keep its intrinsic width before visible response content arrives. */
    compact?: boolean;
  }>(),
  {
    bare: false,
    compact: false,
  },
);

const isUser = computed(() => props.role === CopilotRoleEnum.USER);

/** The design gives the user a bubble that hugs its text and the assistant one that fills the panel. */
const bubbleClass = computed(() => messageBubbleClassOf(props.role, props.bare, props.compact));

const speakerLabel = computed(() => messageSpeakerLabelOf(props.role));
</script>

<template>
  <!-- No author name painted above the bubble: its side and its colour say who is speaking. -->
  <div class="flex flex-col" :class="isUser ? 'items-end' : 'items-start'">
    <div class="rounded-lg" :class="bubbleClass">
      <!-- For a screen reader only, and not while waiting: the loader in there announces itself. -->
      <span v-if="!compact" class="sr-only">{{ speakerLabel }}</span>
      <slot></slot>
    </div>
  </div>
</template>
